import script from "./AppChecklistModelloItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AppChecklistModelloItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__